import { FeedbackSummary } from "~/types/feedback";

export interface Conversation {
  id: string;
  assetId: string;
  assetName: string;
  currentCampaignId: string;
  currentCampaignName: string;
  state: string;
  destination: string;
  location: string;
  currentHeatNumber: number;
  latestResponseOperationDate: string;
  timezoneIdentifier: string;
  // campaignStartDate: string;
  // currentCampaignDate: string;
}

export interface Requests {
  request: Request;
  responses: Response[];
}

export interface RequestResponseViewModel {
  requests: Request[];
  responses: ResponseViewModel[];
}

export interface Request extends BaseRequestResponse {
  userId: string;
  conversationId: string;
  actionType: CopilotRequestActionType;
}

export interface Response extends BaseRequestResponse {
  actionType: CopilotResponseActionType;
  data: string;
  greetingMessages: string[];
  observationMessages: string[];
  checkMessages: { [key: string]: string };
  recommendationMessages: string[];
  feedbackSummary: FeedbackSummary;
}

export interface ResponseViewModel extends Response {
  requestId: string;
  params: MikeMessageParameters;
  isSearched?: boolean;
}

interface BaseRequestResponse {
  id: string;
  data?: string;
  parameters?: string;
  operationDate: string;
}

export enum CopilotRequestActionType {
  LaserScan,
  ThermalScan,
  CampaignCreated,
}

export enum CopilotResponseActionType {
  LaserScan,
  ThermalScan,
  CampaignCreated,
  HealtProcessSummary,
}

export interface MikeMessageParameters {
  [key: string]: unknown;
}

export interface MikeMessageTitle extends MikeMessageParameters {
  HeatNumber: number;
  HeatName: string;
  CampaignName: string;
}

interface CampaingHeatInfo extends MikeMessageTitle {
  CampaignHeatId: string;
}

export interface CampaignCreatedParameterModel extends MikeMessageParameters {
  CampaignId: string;
  CampaignName: string;
}

export interface LaserScanParameterModel extends CampaingHeatInfo {
  LiDARDataId: string;
  LiDARMeasurementsCloudFileKey: string;
  CalculatedLiDARMeasurementsCloudFileKey: string;
}

export interface ThermalScanAnalysisParameters extends CampaingHeatInfo {
  SetId: string;
  Hotspots?: ThermalHotspot[];
}

export interface ThermalHotspot {
  Id: number;
  FrameLocation: number;
  MaxTemp: number;
  MaxX: number;
  MaxY: number;
  MinX: number;
  MinY: number;
}

export interface ThermalLiDARResponseParameters extends MikeMessageParameters {
  ProcessedHeatThermalData: ThermalScanAnalysisParameters;
  LiDARData: LaserScanParameterModel;
}

export interface HealtProcessSummaryResponseParameters
  extends MikeMessageParameters {
  CampaignHeat: CampaingHeatInfo;
  MinCourseClockThicknessAlgorithmResponse: MinCourseClockThicknessAlgorithmResponse;
  AlarmsAndCriticalGrades: AlarmsAndCriticalGrades;
  ReladleCounts: ReladleCount;
}

interface ReladleCount {
  FromCampaign: number;
  ToCampaign: number;
}
interface AlarmsAndCriticalGrades {
  Alarms: {
    Title: string;
    Status: boolean;
    Message: string;
  }[];
  CriticalGradeHeatNumbers: number[];
  MessageForProcessParametres: {
    CurrentCumulativeEtto: number;
    WarningThreshold: number;
    StartPoint: number;
    EndPoint: number;
    Mean: number;
  };
  HeatEttosAndLongRunningHeats: HeatEtto[];
}

interface MinCourseClockThicknessAlgorithmResponse {
  CriticalCourseClock: { Course: number; Clock: number };
  CriticalCourseClockThickness: {
    [key: string]: number;
  };
  ThicknessProjectedLe: number[];
  ThicknessProjectedMe: number[];
  PredictedHeatNumberLe: number;
  PredictedHeatNumberMe: number;
  GrayIndices: number[];
  SlagReplacementHeatNumbers: [17];
  CleanedFilteredPredictedThickness: {
    [key: string]: number;
  };
  Version: string;
}

//Socket Types
export interface RequestResponseSocketModel {
  Request: RequestSocketModel;
  Responses: ResponseSocketModel[];
}

export interface RequestSocketModel {
  Id: string;
  UserId: string;
  ConversationId: string;
  ActionType: CopilotRequestActionType;
  OperationDate: string;
}

export interface ResponseSocketModel {
  Id: string;
  RequestId: string;
  Parameters: string;
  OperationDate: string;
  GreetingMessages: string[];
  ObservationMessages: string[];
  CheckMessages: { [key: string]: string };
  RecommendationMessages: string[];
  ActionType: CopilotResponseActionType;
  Data: string;
  FeedbackSummary: FeedbackSummary;
}
export interface HeatEtto {
  HeatNumber: number;
  Etto: number;
  Flag180Min: boolean;
}
export interface CampaignHeatsForAsset {
  displayText: string;
  campaignHeatId: string;
}

export interface ConversationResponse {
  conversationId: string;
  responseId?: string;
  responsesMap?: Record<string, ResponseViewModel[]>;
}

export interface AddingFeedbackInput {
  CopilotResponseId: string;
  CopilotConversationId: string;
  DefinitionId?: number;
  Description?: string;
}
